import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import 'react-image-gallery/styles/css/image-gallery.css';
import { Button } from 'semantic-ui-react';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import { FormattedMessage } from 'react-intl';

import galleryLeftSVG from '@plone/volto/icons/left-key.svg';
import galleryRightSVG from '@plone/volto/icons/right-key.svg';
import galleryPlaySVG from '@plone/volto/icons/play.svg';
import galleryPauseSVG from '@plone/volto/icons/pause.svg';
import galleryFullScreenSVG from '@plone/volto/icons/fullscreen.svg';
import galleryBackDownSVG from '@plone/volto/icons/back-down.svg';

const ImageGallery = loadable(() => import('react-image-gallery'));

const renderLeftNav = (onClick, disabled) => {
  return (
    <Button
      type="button"
      className="image-gallery-icon image-gallery-left-nav primary basic"
      disabled={disabled}
      onClick={onClick}
    >
      <span className="visually-hidden"><FormattedMessage id="Previous" defaultMessage="Previous" /></span>
      <Icon name={galleryLeftSVG} size="48px" fill="black" />
    </Button>
  );
};
const renderRightNav = (onClick, disabled) => {
  return (
    <Button
      type="button"
      className="image-gallery-icon image-gallery-right-nav primary basic"
      disabled={disabled}
      onClick={onClick}
    >
      <span className="visually-hidden"><FormattedMessage id="Next" defaultMessage="Next" /></span>
      <Icon name={galleryRightSVG} size="48px" />
    </Button>
  );
};

const renderPlayPauseButton = (onClick, isPlaying) => (
  <Button
    icon
    type="button"
    className="image-gallery-icon image-gallery-play-button"
    onClick={onClick}
  >
    <span className="visually-hidden"><FormattedMessage id="Play or Pause Slideshow" defaultMessage="Play or Pause Slideshow" /></span>
    {isPlaying ? (
      <Icon name={galleryPauseSVG} size="20px" />
    ) : (
      <Icon name={galleryPlaySVG} size="20px" />
    )}
  </Button>
);

const renderFullscreenButton = (onClick, isFullscreen) => {
  return (
    <Button
      icon
      type="button"
      className="image-gallery-icon image-gallery-fullscreen-button "
      onClick={onClick}
    >
      {isFullscreen ? (
        <>
          <span className="visually-hidden"><FormattedMessage id="Open Fullscreen" defaultMessage="Open Fullscreen" /></span>
          <Icon name={galleryBackDownSVG} size="20px" />
        </>
      ) : (
        <>
          <span className="visually-hidden"><FormattedMessage id="Close Fullscreen" defaultMessage="Close Fullscreen" /></span>
          <Icon name={galleryFullScreenSVG} size="20px" />
        </>
      )}
    </Button>
  );
};

const ImageGalleryTemplate = ({ items }) => {
  const { settings } = config;
  const renderItems = items.filter(
    (content) =>
      settings.imageObjects.includes(content['@type']) && content.image_field,
  );
  const imagesInfo = renderItems.map((item) => {
    return {
      original: `${flattenToAppURL(item['@id'])}/@@images/${item.image_field
        }/large`,
      thumbnail: `${flattenToAppURL(item['@id'])}/@@images/${item.image_field
        }/thumb`,
    };
  });

  return (
    renderItems.length > 0 && (
      <ImageGallery
        items={imagesInfo}
        renderLeftNav={renderLeftNav}
        renderRightNav={renderRightNav}
        renderPlayPauseButton={renderPlayPauseButton}
        renderFullscreenButton={renderFullscreenButton}
        lazyLoad={true}
      />
    )
  );
};

ImageGalleryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default ImageGalleryTemplate;
